import DashboardTransactions from './DashboardTransactions';

export default DashboardTransactions;
